const Footer = () => {
  const websiteName = process.env.REACT_APP_WEBSITE_NAME || 'LPIPM Politeknik Bisnis Digital Indonesia';
  const websiteShortName = process.env.REACT_APP_WEBSITE_SHORT_NAME || 'LPIPM';
  const address = process.env.REACT_APP_ADDRESS || 'Jl. Contoh No. 123, Jakarta';
  const phone = process.env.REACT_APP_PHONE || '(021) 1234-5678';
  const email = process.env.REACT_APP_EMAIL || 'lpipm@polibis.ac.id';

  return (
    <footer className="bg-dark-blue-900 text-white py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
                <svg className="w-6 h-6 text-dark-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-bold">{websiteShortName}</h3>
                <p className="text-sm text-dark-blue-200">Politeknik Bisnis Digital Indonesia</p>
              </div>
            </div>
            <p className="text-dark-blue-200 text-sm leading-relaxed mb-4">
              Lembaga Penelitian dan Pengabdian kepada Masyarakat yang berfokus pada pengembangan ilmu pengetahuan dan teknologi di bidang bisnis digital.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Navigasi</h4>
            <ul className="space-y-2 text-dark-blue-200">
              <li>
                <a href="/" className="hover:text-white transition-colors">Beranda</a>
              </li>
              <li>
                <a href="/books" className="hover:text-white transition-colors">Buku</a>
              </li>
              <li>
                <a href="/news" className="hover:text-white transition-colors">Berita</a>
              </li>
              <li>
                <a href="/information" className="hover:text-white transition-colors">Informasi</a>
              </li>
              <li>
                <a href="/hubungi-kami" className="hover:text-white transition-colors">Hubungi Kami</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Kategori Berita</h4>
            <ul className="space-y-2 text-dark-blue-200">
              <li>
                <a href="/news/literasi" className="hover:text-white transition-colors">Literasi</a>
              </li>
              <li>
                <a href="/news/pengembangan" className="hover:text-white transition-colors">Pengembangan Penulisan</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Kontak Kami</h4>
            <ul className="space-y-3 text-dark-blue-200">
              <li className="flex items-start gap-3">
                <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="leading-relaxed">{address}</span>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href={`mailto:${email}`} className="hover:text-white transition-colors">{email}</a>
              </li>
              <li className="flex items-center gap-3">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href={`tel:${phone}`} className="hover:text-white transition-colors">{phone}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-dark-blue-800 mt-10 pt-6 text-center text-dark-blue-300 text-sm">
          <p>&copy; {new Date().getFullYear()} {websiteName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
